import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9ee6bb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "role-table" }
const _hoisted_2 = { class: "operate" }
const _hoisted_3 = { class: "operate-search" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用户名：", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手机号/账号：", -1))
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { class: "order" }
const _hoisted_8 = { class: "status" }
const _hoisted_9 = { class: "op" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["disabled", "onClick"]

import {
  ref, unref, reactive, computed, watch, withDefaults,
} from 'vue';
import { useStore, } from 'vuex';
import {
  Input, Table, ConfigProvider, Switch, message,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

import { debounce, } from '@/utils/index';

import { ColumnProps, } from 'ant-design-vue/es/table/interface';
import CreateModal from '../newModal/index.vue';
import EditModal from '../editModal/index.vue';
import ImportModal from '../importModal/index.vue';
import PasswordModal from '../passwordModal/index.vue';

type Key = ColumnProps['key'];

type ColumnType = {
  title: string;
  align?: string,
  dataIndex?: string;
  slots?: any;
  width?: any;
  ellipsis?: boolean;
};

interface Props {
  selectedKey: string,
  selectedLevel: string,
}

// 列表行配置
interface FormState {
  name: string | undefined;
  tel: string | undefined;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    selectedKey: { default: '' },
    selectedLevel: { default: '' }
  },
  setup(__props: any) {

const props = __props as { selectedKey: string, selectedLevel: string }

const store = useStore();

const columns: ColumnType[] = [
  {
    title: '序号',
    align: 'center',
    slots: { customRender: 'index', },
    width: '4%',
  },
  {
    title: '用户名',
    dataIndex: 'name',
    width: '6%',
    ellipsis: true,
  },
  {
    title: '组织',
    dataIndex: 'company',
    width: '6%',
    ellipsis: true,
  },
  {
    title: '上级组织',
    dataIndex: 'dept',
    width: '6%',
    ellipsis: true,
  },
  {
    title: '职位',
    dataIndex: 'position',
    width: '5%',
    ellipsis: true,
  },
  {
    title: '角色',
    dataIndex: 'roleName',
    width: '6%',
    ellipsis: true,
  },
  {
    title: '手机号/账号',
    dataIndex: 'tel',
    width: '8%',
    ellipsis: true,
  },
  {
    title: '账号',
    dataIndex: 'accountName',
    width: '6%',
    ellipsis: true,
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    width: '6%',
    ellipsis: true,
  },
  {
    title: '账号创建时间',
    dataIndex: 'createTime',
    width: '8%',
    ellipsis: true,
  },
  {
    title: '账号到期时间',
    dataIndex: 'expirationTime',
    width: '8%',
    ellipsis: true,
  },
  {
    title: '工单账号',
    dataIndex: 'isOrderAccept',
    slots: { customRender: 'order', },
    width: '6%',
  },
  {
    title: '账号状态',
    dataIndex: 'isValid',
    slots: { customRender: 'status', },
    width: '6%',
  },
  {
    title: '操作',
    slots: { customRender: 'op', },
    width: '17%',
  },
];



// 表格数据
const tableData = ref<any>([]);
const current = ref<number>(1);
const total = ref<number>(0);

const search = reactive<FormState>({
  name: '',
  tel: '',
});

/**
 * 加载表格数据
 * @param {*} companyId 当前层id
 * @param {*} pageNo 当前页码
 * @param {*} searchValue 查询字符
 * @return {void}
 */
const loadUserTable = (companyId: any, pageNo = 1, searchValue = false): void => {
  const params = searchValue ?
    {
      tel: search.tel,
      name: search.name,
      companyId,
      type: 'ALL',
      pageNo,
      pageSize: 10,
    } :
    {
      companyId,
      type: 'ALL',
      pageNo,
      pageSize: 10,
    };

  store.dispatch('userCenter/getUserList', params);
};

const loadRole = (): void => {
  store.dispatch('userCenter/getAllRoleList');
};

watch(
  () => [props.selectedKey,props.selectedLevel,],
  (newProps) => {
    search.name = '';
    search.tel = '';
    current.value = 1;
    loadUserTable(newProps[0]);
  }
);

// 加载全部用户数据
loadUserTable('');
// 获取全部角色
loadRole();

// 选中的id
const selectedKeys = ref<any[]>([]);
// 选中的row
const selectedRow = ref<Key[]>([]);
// 列表数据
const userList = computed(() => store.state.userCenter.userList);
// 角色数据
const roleList = computed(() => store.state.userCenter.allRoleList);

watch(userList, (val) => {
  tableData.value = val.list;
  total.value = val.total;
  selectedKeys.value = [];
  selectedRow.value = [];
},{
  deep: true,
});

const handleSearch = ():void => {
  current.value = 1;

  loadUserTable(props.selectedKey, current.value , true);
};

const rowSelection = computed(() => ({
  selectedRowKeys: unref(selectedRow),
  onChange: (selectedRowKeys: Key[], selectedRows: any[]) => {
    selectedRow.value = selectedRowKeys;
    selectedKeys.value = [];
    // 获取选中的ids
    selectedRows.forEach((item: any) => {
      selectedKeys.value.push(item.id);
    });
  },
}));

/**
 * @method recursive
 * @param {any[]} list 递归的数组
 * @param {number} layer 递归层数
 * @returns {any[]} 数组
 */
const recursive = (list: any[], layer = 1): any[] => {
  const temp: any[] = [];

  list.forEach((item: any) => {
    temp.push(item.children ?
      {
        value: item.company,
        title: item.company,
        key: item.id,
        ...item,
        children: recursive(item.children, layer + 1),
      } :
      {
        value: item.company,
        title: item.company,
        key: item.id,
        ...item,
      });
  });

  return temp;
};

// 组织架构
const oriFramework = computed(() => store.state.userCenter.origanizationFramework);
// 新建用户弹窗显隐
const modalVisible = ref<boolean>(false);
// 编辑用户显隐
const editVisible = ref<boolean>(false);
// 导入弹窗显隐
const importVisible = ref<boolean>(false);
// 修改密码弹窗显隐
const passwordVisible = ref<boolean>(false);
// 组织列表
const organizations = ref<any[]>([]);
// 角色列表
const roles = ref<any>([]);
// 用户信息
const userInfo = ref<any>();
// 当前人员
const currentUser = ref<any>({});
// 当前类型
const currentType = ref<string>('');
const roleData = ref<string>('');

const handleNew = (): void => {
  organizations.value = recursive(oriFramework.value);
  roles.value = roleList.value;
  modalVisible.value = true;
};

/**
 * @method handleImport
 * @return {void} 批量导入
 */
const handleImport = (): void => {
  importVisible.value = true;
};

/**
 * @method handleOutPort
 * @return {void} 导出
 */
const handleExport = (): void => {
  const params = {
    companyId: props.selectedKey,
    name: search.name,
    tel: search.tel,
  };

  // 调取接口下载
  store.dispatch('userCenter/exportUserInfo', params);
};

// 账号解锁
const handleUnlock = (id: any): void => {
  store.dispatch('userCenter/unlockUser', [id,]).then(() => {
    loadUserTable(props.selectedKey, current.value , true);
  });
};

/**
 * @method handleEdit
 * @param {any} item 编辑的对象
 * @return {void}
 */
const handleEdit = (item: any): void => {
  organizations.value = recursive(oriFramework.value);
  roles.value = roleList.value;
  userInfo.value = item;
  editVisible.value = true;
  store.dispatch('userCenter/getDataType', item.roleId).then((data) => {
    roleData.value = data.dataType;
  });
};

const handleSubmit = debounce(() => {
  const {
    id, isOrderAccept, isValid,
  } = currentUser.value;
  const params = currentType.value === 'order' ?
    {
      id,
      isOrderAccept: isOrderAccept === '1' ?
        '0' :
        '1',
    } :
    {
      id,
      isValid: isValid === '1' ?
        '0' :
        '1',
    };

  store.dispatch('userCenter/saveUser', params).then(() => {
    loadUserTable(props.selectedKey, current.value, true);
  });
}, 1000);

/**
 * @method switchClick
 * @param {any} value 状态
 * @param {any} type switch类型
 * @return {void}
 */
const switchClick = (value: any, type: any) :void => {
  currentUser.value = value;
  currentType.value = type;
  handleSubmit();
};

/**
 * @method handlePassword
 * @param {any} item 用户对象
 * @return {void}
 */
const handlePassword = (item: any): void => {
  userInfo.value = item;
  passwordVisible.value = true;
};

/**
 * @method handleChange
 * @param {any[]} page 传入当前点击的页码
 * @param {any[]} pageSize 传入当前点击的页数
 * @return {void}
 */
const handleChange = (page: any, pageSize: any) => {
  current.value = page;
  loadUserTable(props.selectedKey, page, true);
};

const cancal = (str: string): void => {
  if (str === 'create') {
    modalVisible.value = false;
  } else if (str === 'edit') {
    editVisible.value = false;
  } else if (str === 'import') {
    importVisible.value = false;
  } else {
    passwordVisible.value = false;
  }
};

const save = (str: string): void => {
  if (str === 'create') {
    modalVisible.value = false;
  } else if (str === 'edit') {
    editVisible.value = false;
  } else if (str === 'import') {
    importVisible.value = false;
  } else {
    passwordVisible.value = false;
  }
  loadUserTable(props.selectedKey, current.value, true);
  // 加载左侧树结构数据
  store.dispatch('userCenter/getOriFramework');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _createVNode(_unref(Input), {
            value: _unref(search).name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(search).name) = $event)),
            placeholder: ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_5,
          _createVNode(_unref(Input), {
            value: _unref(search).tel,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(search).tel) = $event)),
            placeholder: ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("button", {
          class: "btn search",
          onClick: handleSearch
        }, "查询")
      ]),
      _createElementVNode("div", { class: "operate-button" }, [
        _createElementVNode("button", {
          class: "btn",
          onClick: handleNew
        }, "新建"),
        _createElementVNode("button", {
          class: "btn",
          onClick: handleImport
        }, "导入"),
        _createElementVNode("button", {
          class: "btn",
          onClick: handleExport
        }, "导出")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(ConfigProvider), { locale: _unref(zhCN) }, {
        default: _withCtx(() => [
          _createVNode(_unref(Table), {
            columns: columns,
            scroll: {
            y: '5.6rem'
          },
            pagination: {
            total:total.value,
            pageSize:10,
            size:'small',
            current:current.value,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条`,
            onChange: (page, pageSize) => handleChange(page, pageSize),
          },
            "data-source": tableData.value,
            "row-selection": _unref(rowSelection),
            rowKey: (record) => record.id
          }, {
            index: _withCtx(({ index,}) => [
              _createElementVNode("span", null, _toDisplayString(index + 1), 1)
            ]),
            order: _withCtx(({ text, record, }) => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(Switch), {
                  checked: text === '1',
                  size: "small",
                  onClick: ($event: any) => (switchClick(record, 'order'))
                }, null, 8, ["checked", "onClick"])
              ])
            ]),
            status: _withCtx(({ text, record, }) => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(Switch), {
                  checked: text === '1',
                  size: "small",
                  onClick: ($event: any) => (switchClick(record, 'status'))
                }, null, 8, ["checked", "onClick"])
              ])
            ]),
            op: _withCtx(({ text, }) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (handlePassword(text))
                }, "重置密码", 8, _hoisted_10),
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleEdit(text))
                }, "编辑", 8, _hoisted_11),
                _createElementVNode("button", {
                  disabled: text.isFrozen ==='1',
                  onClick: ($event: any) => (handleUnlock(text.id))
                }, "解锁", 8, _hoisted_12)
              ])
            ]),
            _: 1
          }, 8, ["scroll", "pagination", "data-source", "row-selection", "rowKey"])
        ]),
        _: 1
      }, 8, ["locale"])
    ]),
    _createVNode(CreateModal, {
      "create-visible": modalVisible.value,
      organizations: organizations.value,
      roles: roles.value,
      selectedCompany: props.selectedKey,
      onCancal: _cache[2] || (_cache[2] = ($event: any) => (cancal('create'))),
      onSave: _cache[3] || (_cache[3] = ($event: any) => (save('create')))
    }, null, 8, ["create-visible", "organizations", "roles", "selectedCompany"]),
    _createVNode(PasswordModal, {
      "password-visible": passwordVisible.value,
      "user-info": userInfo.value,
      onCancal: _cache[4] || (_cache[4] = ($event: any) => (cancal('password'))),
      onSave: _cache[5] || (_cache[5] = ($event: any) => (save('password')))
    }, null, 8, ["password-visible", "user-info"]),
    _createVNode(EditModal, {
      "edit-visible": editVisible.value,
      organizations: organizations.value,
      roles: roles.value,
      "user-info": userInfo.value,
      onCancal: _cache[6] || (_cache[6] = ($event: any) => (cancal('edit'))),
      onSave: _cache[7] || (_cache[7] = ($event: any) => (save('edit'))),
      roleData: roleData.value
    }, null, 8, ["edit-visible", "organizations", "roles", "user-info", "roleData"]),
    _createVNode(ImportModal, {
      "import-visible": importVisible.value,
      onCancal: _cache[8] || (_cache[8] = ($event: any) => (cancal('import'))),
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (save('import')))
    }, null, 8, ["import-visible"])
  ]))
}
}

})